import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import WeekText from "../Week/WeekText.js";
import data from "../../../Data/weeks/weeksData.json";

export default function WeekPage() {
  return (
    <section className="structure">
      <Breadcrumbs />

      <h1 className="weekpage__title">
        Мероприятия по профилактике заболеваний и поддержке здорового образа
        жизни
      </h1>
      <div>
        <WeekText data={data} />
      </div>
    </section>
  );
}
